import { GameInfoService } from './service/GameInfoService'
import { gameInfoApi } from './api/gameInfoApi'

export const gameInfoService = new GameInfoService(gameInfoApi)
